<section class="{{ class }}">
    <div class="text-center">
      <div class="justify-content-between mb-2">
        <h4>Zugang Angebotsübersicht</h4>
      </div>
      <div class="justify-content-between mb-3 text-dark-grey">
        <p>Bitte gebe den 6-stelligen Sicherheitscode, <br> welchen wir dir mit deinem Angebotslink zugesendet haben.</p>
      </div>
      <div class="flex justify-between self-stretch text-black {{ class + '__security-code-text'}}">
          <p>Sicherheitscode</p>
      </div>
      <div class="flex justify-content-center"> 
        <p-inputOtp [(ngModel)]="otpCode"  [length]="6" size="large" />
      </div>
      <div  class="flex justify-content-center mt-5">
            <p-button (click)="verifyOtp()" label="Show" 
              [label]="'Bestätigen'" 
              [icon]="'pi pi-arrow-right'"
              iconPos="right"
              [class]="'p-text-normal'"
              [loading]="isVerifying"
              [disabled]="false" /> 
      </div>
      <div class="flex justify-content-center mt-2 {{ class + '__invalid-code'}}">
          <span class="small-text text-primary-color" *ngIf="invalidOtp">
          {{ "Ungültiger OTP-Code" }}
          </span>
      </div>
      <div class="justify-content-between mt-3 text-dark-grey">
        <p>Probleme bei der Verifizierung?</p>
      </div>
      <div class="justify-content-between text-underlined {{ class + '__resend-otp'}}">
          <p-button label="Code erneut senden" [text]="true" [loading]="isResendingOtp" (onClick)="resedOtp()" /> 
      </div>
  </div>
</section>
